import {useState} from 'react';
import './GuestForm.scss';

const GuestForm = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    canAttend: '',
    allergies: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const apiUrl = process.env.NODE_ENV === 'development'
        ? 'http://localhost:3001/api/guest-form/submit'
        : '/api/guest-form/submit';

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          fullName: '',
          canAttend: '',
          allergies: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="guest-form">
      <h2 className="guest-form__title">Анкета гостя</h2>

      {submitStatus === 'success' && (
        <div className="guest-form__message guest-form__message--success">
          Спасибо! Ваша анкета успешно отправлена.
        </div>
      )}

      {submitStatus === 'error' && (
        <div className="guest-form__message guest-form__message--error">
          Произошла ошибка. Пожалуйста, попробуйте ещё раз.
        </div>
      )}

      {submitStatus !== 'success' && (
        <form className="guest-form__form" onSubmit={handleSubmit}>
          <div className="guest-form__group">
            <label className="guest-form__label" htmlFor="fullName">Ваши Фамилия и Имя</label>
            <input
              className="guest-form__input"
              type="text"
              id="fullName"
              name="fullName"
              value={formData.fullName}
              onChange={handleInputChange}
              placeholder="Введите ваши ФИО"
              required
            />
          </div>

          <div className="guest-form__group">
            <label className="guest-form__label" htmlFor="canAttend">Присутствие</label>
            <select
              className="guest-form__select"
              id="canAttend"
              name="canAttend"
              value={formData.canAttend}
              onChange={handleInputChange}
              required
            >
              <option value="">Выберите вариант</option>
              <option value="yes">Да, буду присутствовать</option>
              <option value="no">К сожалению, не смогу</option>
            </select>
          </div>

          <div className="guest-form__group">
            <label className="guest-form__label" htmlFor="allergies">Аллергии</label>
            <textarea
              className="guest-form__textarea"
              id="allergies"
              name="allergies"
              value={formData.allergies}
              onChange={handleInputChange}
              placeholder="Укажите аллергии или особые пищевые предпочтения."
            />
          </div>

            <button className="guest-form__button" type="submit" disabled={isSubmitting}>
              {isSubmitting ? 'Отправляем...' : 'Отправить анкету'}
            </button>

        </form>
      )}

      <p className="guest-form__deadline">
        Об изменениях просим сообщить до 01.06.2026
      </p>
    </section>
  );
};

export default GuestForm;
